import React, { useState } from 'react';
import { FiMenu, FiSearch, FiUser, FiLogOut, FiSettings, FiGlobe } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../features/auth/hooks/useAuth';
import './Header.css';

interface HeaderProps {
  toggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === 'tr' ? 'en' : 'tr';
    i18n.changeLanguage(newLang);
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-btn" onClick={toggleSidebar}>
          <FiMenu />
        </button>
        <div className="search-bar">
          <FiSearch className="search-icon" />
          <input 
            type="text" 
            placeholder={t('header.search')}
            className="search-input"
          />
        </div>
      </div>
      
      <div className="header-right">
        <button className="language-btn" onClick={toggleLanguage} title={t('header.language')}>
          <FiGlobe />
          <span>{i18n.language.toUpperCase()}</span>
        </button>

        <div className="user-info" onClick={() => setShowDropdown(!showDropdown)}>
          <div className="user-avatar">
            {user?.avatar ? (
              <img src={user.avatar} alt={user.name} />
            ) : (
              <FiUser />
            )}
          </div>
          <span className="user-name">{user?.name || t('header.profile')}</span>
          
          {showDropdown && (
            <div className="user-dropdown">
              <div className="dropdown-item">
                <FiSettings />
                <span>{t('header.settings')}</span>
              </div>
              <div className="dropdown-item" onClick={handleLogout}>
                <FiLogOut />
                <span>{t('header.logout')}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;

